export default __webpack_public_path__ + "static/media/help2.bfb5bd08.svg";